var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1109_5550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 18.9997V13.9997H14V18.9997C14 19.5497 14.45 19.9997 15 19.9997H18C18.55 19.9997 19 19.5497 19 18.9997V11.9997H20.7C21.16 11.9997 21.38 11.4297 21.03 11.1297L12.67 3.59973C12.29 3.25973 11.71 3.25973 11.33 3.59973L2.96998 11.1297C2.62998 11.4297 2.83998 11.9997 3.29998 11.9997H4.99998V18.9997C4.99998 19.5497 5.44998 19.9997 5.99998 19.9997H8.99998C9.54998 19.9997 9.99998 19.5497 9.99998 18.9997Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_5550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboardActive.dcdaeee92f1050b730233dcfaf89978a.svg";
export { ForwardRef as ReactComponent };